import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ChangePasswordService } from './changepassword.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {encryptdecrypt} from '../encryptdecrypt';
import { LocalService } from '../local.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {
  changepsswordForm: FormGroup;
  postresult: boolean; 
  userid: string;
  submitted = false;
  loading = false;
 passwordComplexity=0;
 
  encryptUsername=''; encryptPassword='';encryptUserid='';
  public barLabel: string = "Password strength:";
  public account = {  
        password: null  
      }; 
  constructor(private formBuilder: FormBuilder,
    private changeservice: ChangePasswordService,
    private toastr: ToastrService,
    private route: ActivatedRoute, private localService: LocalService) { }

  ngOnInit() {
    this.changepsswordForm = this.formBuilder.group({
      oldpassword: ['', Validators.required],
      newpassword: ['', Validators.required],
      confirmpassword: ['', Validators.required]
    });

    
   
  }


  getfrmValue($event) {    
    this.passwordComplexity = $event;
      }

  /*encryptUsingAES256(plaintext) {
    let key = CryptoJS.enc.Utf8.parse(this.encryptKey);
    let iv = CryptoJS.enc.Utf8.parse(this.encryptKey);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plaintext), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    console.log('Encrypted :' + encrypted);
   
    return encrypted;
}

decryptUsingAES256(decString) {
  var decrypted = CryptoJS.AES.decrypt(decString, this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
  });
  console.log('Decrypted : ' + decrypted);
  console.log('utf8 = ' + decrypted.toString(CryptoJS.enc.Utf8));

}*/
  get f() { return this.changepsswordForm.controls; }


  onSubmit(http: HttpClient) {
    this.submitted = true;
    this.loading = true;
   
   
    //var username = localStorage.getItem("emailid");
    var username = this.localService.getJsonValue("emailid");

    if(+this.passwordComplexity <=69){
      this.toastr.error("Please use complex password");
      return;
    }

    if (this.f.newpassword.value != this.f.confirmpassword.value) {
      this.toastr.error("Confirm password and new password should be same");
      return;
    }
    if (this.f.oldpassword.value == this.f.newpassword.value) {
      this.toastr.error("Old password and new password should not be same");
      return;
    }

    
    let a= new encryptdecrypt();
  
    this.encryptUsername = a.encryptUsingAES256(username.toString());
   this.encryptPassword = a.encryptUsingAES256(this.f.oldpassword.value.toString());
    this.changeservice.checkoldpassword(this.encryptPassword.toString(), this.encryptUsername.toString()).subscribe(res =>
    {
      //console.log(res);
      if (res.status == 200) { this.postresult = true; this.changepassword(); };
       },
      error => {
        this.toastr.error(error.error);
        this.loading = false;
        return;
        this.postresult = false
      })
   
    
     
      
      
   
  }

  changepassword() {
    //var useridnew = localStorage.getItem("userid");
    var useridnew = this.localService.getJsonValue("userid");
    let a= new encryptdecrypt();
    this.encryptPassword = a.encryptUsingAES256(this.f.newpassword.value.toString());
  this.encryptUserid=a.encryptUsingAES256(useridnew.toString());

    this.changeservice.changepassword(this.encryptPassword.toString(), this.encryptUserid.toString()).subscribe(res => {
     // console.log(res);
      if (res.status == 200) {
    this.postresult = true;
      this.toastr.success('Password Reset has been done successfully');
      this.changepsswordForm.controls['oldpassword'].setValue('');
      this.changepsswordForm.controls['newpassword'].setValue('');
      this.changepsswordForm.controls['confirmpassword'].setValue('');
      
    };
      },
      error => {
        this.toastr.error(error.error);
        this.postresult = false
      })
  }
}
